/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
/**
 *
 * 循环使用setTimeout 调用 fn
 *
 * @param {*} fn
 * @param {*} LoopOption
 * @return
 */
export type LoopOption = {
  interval: number;
  immediate?: boolean;
};
export function loop(
  fn: (...args: unknown[]) => void,
  { interval, immediate = true }: LoopOption = { interval: 1e3 }
) {
  let thread: number;
  let stopped = false;

  const run = async () => {
    await fn();
    nextTime();
  };

  const clear = () => {
    clearTimeout(thread);
  };
  const nextTime = () => {
    clear();
    if (stopped) {
      return;
    }
    thread = setTimeout(run, interval) as unknown as number;
  };
  const stop = () => {
    clear();
    stopped = true;
  };

  if (immediate) {
    run();
  } else {
    nextTime();
  }

  return stop;
}
